export default __webpack_public_path__ + "50643d4956c621125b939f9eb9eb1d8f.svg";